import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@lib/auth/data-access';
import { FeatureToggleService } from '@lib/feature-toggle/data-access';
import { FeatureToggleType } from '@lib/feature-toggle/models';
import { ToastMessageOptions } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'lib-notification-feature-integration-notification',
  imports: [
    RouterModule,
    ToastModule,
    AvatarModule,
    AvatarGroupModule,
    TooltipModule
  ],
  templateUrl: './integration-notification.component.html',
  styleUrl: './integration-notification.component.scss',
})
export class IntegrationNotificationComponent {
  public message = input.required<ToastMessageOptions>();
  public tenantExternalIdComputed = computed(() => { return this.authService.currentTenantExternalIdComputedSignal() });

  // inject
  private router = inject(Router);
  public authService = inject(AuthService);
  private featureToggleService = inject(FeatureToggleService);
  // public
  public isNotificationFeatureEnabled = computed(() => { return this.featureToggleService.tenantFeaturesComputedSignal().some(feature => feature.id === FeatureToggleType.Notifications && feature.isEnabled) })

}
